import { render } from "./Smtp.vue?vue&type=template&id=f8afb416"
import script from "./Smtp.vue?vue&type=script&lang=js"
export * from "./Smtp.vue?vue&type=script&lang=js"

import exportComponent from "/home/mugonat-caaz-omnibox/htdocs/caaz-omnibox.mugonat.com/releases/21/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__